'use client';

import { useState } from 'react';
import Icon from '@/components/ui/AppIcon';

interface BulkActionsToolbarProps {
  selectedCount: number;
  onReschedule: (date: string) => void;
  onCancel: () => void;
  onClear: () => void;
}

export default function BulkActionsToolbar({ selectedCount, onReschedule, onCancel, onClear }: BulkActionsToolbarProps) {
  const [rescheduleDate, setRescheduleDate] = useState('');
  const [showReschedule, setShowReschedule] = useState(false);

  const handleReschedule = () => {
    if (rescheduleDate) {
      onReschedule(rescheduleDate);
      setRescheduleDate('');
      setShowReschedule(false);
    }
  };

  return (
    <div className="flex items-center gap-3 px-4 py-2.5 bg-secondary/10 border-b border-secondary/20 flex-shrink-0 flex-wrap">
      <div className="flex items-center gap-2">
        <div className="w-6 h-6 rounded-full bg-secondary text-white flex items-center justify-center">
          <span className="text-xs font-heading font-bold">{selectedCount}</span>
        </div>
        <span className="text-sm font-body font-medium text-secondary">jobs selected</span>
      </div>

      <div className="flex items-center gap-2 ml-2">
        <button
          onClick={() => setShowReschedule(p => !p)}
          className="flex items-center gap-1.5 px-3 py-1.5 text-sm font-body bg-secondary text-white rounded-md hover:bg-accent transition-standard"
        >
          <Icon name="CalendarDaysIcon" size={15} variant="solid" />
          Bulk Reschedule
        </button>

        {showReschedule && (
          <div className="flex items-center gap-2">
            <input
              type="date"
              value={rescheduleDate}
              onChange={e => setRescheduleDate(e.target.value)}
              className="px-2 py-1.5 text-sm font-body border border-border rounded-md bg-card text-foreground focus:outline-none focus:ring-2 focus:ring-primary"
            />
            <button
              onClick={handleReschedule}
              disabled={!rescheduleDate}
              className="px-3 py-1.5 text-sm font-body bg-primary text-white rounded-md hover:bg-secondary transition-standard disabled:opacity-50"
            >
              Apply
            </button>
          </div>
        )}

        <button
          onClick={onCancel}
          className="flex items-center gap-1.5 px-3 py-1.5 text-sm font-body bg-error/10 text-error border border-error/20 rounded-md hover:bg-error/20 transition-standard"
        >
          <Icon name="XCircleIcon" size={15} />
          Cancel Jobs
        </button>

        <button
          className="flex items-center gap-1.5 px-3 py-1.5 text-sm font-body bg-warning/10 text-warning border border-warning/20 rounded-md hover:bg-warning/20 transition-standard"
        >
          <Icon name="BellAlertIcon" size={15} />
          Notify Customers
        </button>
      </div>

      <button onClick={onClear} className="ml-auto p-1.5 rounded-md hover:bg-muted text-muted-foreground hover:text-foreground transition-standard">
        <Icon name="XMarkIcon" size={16} />
      </button>
    </div>
  );
}